import ReactDOM from 'react-dom';
import React from 'react';
import { Counter } from './Counter.js'

ReactDOM.render(
  <Counter />,
  document.getElementById('root')
)
